import React, {useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import {Link, NavLink, useParams} from "react-router-dom";
import {Badge, Button, Dropdown, Offcanvas} from "react-bootstrap";
import * as t from "counterpart";
import {loadCart, toggleOffCanvasCart} from "../actions";
import { ReactComponent as Icon }  from "./style/cart.svg";
import "./style/CartPopup.scss";

let imagePrefix = (process.env.REACT_APP_ENABLE_CLOUDFLARE_IMAGE_RESIZE === "true") ? "/cdn-cgi/image/width=200,quality=90/": "";

export default React.forwardRef(function(props={}, ref)
{
	const dispatch = useDispatch();
	const {store} = useParams();
	const direct = props.direct;

	const {user, ready, items, offCanvasCart} = useSelector(({cart, portal}) => {
		return {
			user: portal.user,
			ready: portal.ready,
			items: cart.items,
			offCanvasCart: cart.offCanvasCart
		};
	});

	props = {
		...props,
		className: "cart-popup-block "+ (props.className || "")
	};

	delete props.direct;

	useEffect(() => {
		if(ready) {
			dispatch(loadCart(!user));
		}
	}, [user, ready]);

	const hideCanvas = () => dispatch(toggleOffCanvasCart(false));

	return (
		<>
			<Dropdown align="end" {...props} ref={ref} as={direct? NavLink : "div"} to={`/${store}/cart`}>
				<Dropdown.Toggle>
					<span className="label">{t("Cart")}</span>
					<Icon />
					{items.length !== 0 && <Badge variant="light">{items.length}</Badge>}
				</Dropdown.Toggle>

				{!direct &&
				<Dropdown.Menu>
					{items.map(item =>
						<Dropdown.Item key={item.id} to={`/${store}/details/${item.slug}-${item.id}`} as={Link} disabled>
							<div className="image" style={{backgroundImage: "url('"+imagePrefix+item.thumbnail+"')"}} />
							<div>
								{item.name}
								<div> {t("Quantity")}: {item.cart_quantity} / {t("Price")}: {item.cart_quantity * (item.current_price + parseFloat(item.cart_options_price || 0) - parseFloat(item.cash_back || 0))}</div>
							</div>
						</Dropdown.Item>
					)}

					{items.length !== 0 &&
					<Button as={Link} to={`/${store}/cart`} variant="outline-primary" style={{display: "block"}}>{t("Browse your cart")}</Button>}

					{items.length === 0 && <div className="empty">{t("There are no items in your cart")}</div>}
				</Dropdown.Menu>}
			</Dropdown>

			<Offcanvas id="cart-offcanvas" show={offCanvasCart} onHide={hideCanvas}>
				<Offcanvas.Header closeButton>
					<Offcanvas.Title>{t("Cart")}</Offcanvas.Title>
				</Offcanvas.Header>
				<Offcanvas.Body>
					{items.map(item => {
						let price = item.current_price + parseFloat(item.cart_options_price || 0) - parseFloat(item.cash_back || 0)

						return (
							<div key={item.id} className="row" style={{marginBottom: 15}}>
								<div className="col-md-4" style={{height: 100, background: "url('"+imagePrefix+item.thumbnail+"') center no-repeat", backgroundSize: "contain"}} />
								<div className="col-md-8">
									{item.name}
									<div> {t("Quantity")}: {item.cart_quantity} / {t("Price")}: {item.cart_quantity * price}</div>
								</div>
							</div>
						)
					})}

					<Button as={Link} onClick={hideCanvas} to={`/${store}/cart`}  variant="outline-primary">{t("Browse your cart")}</Button>
					<Button as={Link} onClick={hideCanvas} to={`/${store}/cart/order`}  variant="success" className="checkout" style={{margin: 5}}>{t("Continue To Checkout")}</Button>
				</Offcanvas.Body>
			</Offcanvas>
		</>
	);
});
